
    
<template>
    <!-- PC端 -->
	<el-container v-if="!GLOBAL.isMobile" class="container">
        <div class="header flex">
            <!-- 左侧logo -->
            <div class="logo">
               <router-link to="/" tag="img" :src="$cdnUrl('ios/logov2.png')" alt="自动洗车机洗车"></router-link>
             </div>
             <!-- 右侧导航 -->
            <div class="nav-box" v-cloak>
                <div :class="['nav-item index-nav', navActiveClass(item)]" v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                    <router-link :to="item.path" class="first-nav">
                        <span>{{item.name}}</span>
                    </router-link>
                    <div class="second-nav-box" v-if="item.children && (item.children.length > 0) && !(item.children.length == 1 && item.children[0].path == item.path)">
                        <div v-for="(children, index) in item.children" v-if="item.path != children.path" :to="children.path" :class="$route.path == children.path ? 'second-nav active': 'second-nav'" @click.self="toRobot(children.path)">
                            <span @click.self="toRobot(children.path)">{{children.name}}</span>
                            <div class="third-nav-box" v-if="children.navs">
                                <div v-for="(nav, index) in children.navs" :class="(index == eventBus.modelIndex && $route.path == children.path)? 'third-nav active' : 'third-nav'" @click.stop="showThisRobot(index, children.path)">
                                    <span>{{nav}}</span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="phone-box">
                <span>
                 <i class="el-icon-phone-outline"></i>
                </span>
                <span>
                    400-666-1098
                </span>
            </div>

            <!-- 导航栏 -->
            <!-- <el-col  class="top-menu flex">
                <el-menu 
                    :default-active="$route.path" 
                    mode="horizontal" 
                    text-color="#373636"
                    active-text-color="#E30B1B"
                    class="el-menu-vertical-demo" 
                    unique-opened 
                    router>
                    <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                        <el-submenu :index="index+''" v-if="!item.leaf">
                            <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if = "item.leaf && item.children.length > 0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
                    </template>
                </el-menu> -->
                <!-- <router-link v-if="!userId" tag="div" to="/login" class="login-box">登录</router-link> -->
                <!-- <router-link v-if="!sessionStorage.getItem('userId')" tag="div" to="/login" class="login-box">登录</router-link> -->
                <!-- <el-dropdown v-else trigger="hover">
                    <span class="el-dropdown-link"><img class="user-icon" :src="'nav/icon_nav_ personal.png' | imgsrc" /></span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided >
                            <router-link tag="p" to="/userInfo">个人资料</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item divided @click.native="clickLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </el-col>
        </div>


		<router-view></router-view>	
        <el-footer :span="24" class="footer">
            <div class="contact">
                <div class="left">
                    <div class="link-box">
                        <span class="item"><router-link to="/">产品介绍</router-link></span>
                        <span class="item"><router-link to="/buyGuide">选购指南</router-link></span>
                        <span class="item"><router-link to="/operMarket">运营支持</router-link></span>
                        <span class="item"><router-link to="/afterSale">售后支持</router-link></span>
                        <span class="item"><router-link to="/about">走进太仆</router-link></span>
                        <!-- <span class="item"><router-link to="/taipuFuture">太仆未来</router-link></span> -->
                        <span class="item"><router-link to="/cityPartners">城市合伙人</router-link></span>
                    </div>
                    <div class="address-box">
                        <!-- <div class="logo footer-tplogo">
                            <router-link to="/">
                                <img :src="$cdnUrl('ios/logo_s.png')" />
                            </router-link>
                        </div> -->
                        <div class="address">
                            <div class="text">
                                公司地址：浙江省杭州市余杭区五常街道165号靖源国际4幢8楼
                            </div>
                            <div class="text">
                                电子邮箱：tpqc@taipuauto.cn
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="bundle">
                        <div class="phone">全国加盟热线：<span class="strong">400-666-1098</span></div>
                        <div class="ex-link-box">
                            <div class="ex-link">
                                <img class="icon" :src="$cdnUrl('website/footer/icon_wx.png')" />
                                <!-- <div class="qr-code">
                                    <img :src="$cdnUrl('ios/operation_applets_QR.png')">
                                </div> -->
                            </div>
                            <div class="ex-link">
                                <img class="icon" :src="$cdnUrl('website/footer/icon_wb.png')" />
                                <!-- <div class="qr-code">
                                    <img :src="$cdnUrl('ios/Bottom_erweima%402x.png')">
                                </div> -->
                            </div>
                            <div class="ex-link" id="footer-icon-sh">
                                <img class="icon" :src="$cdnUrl('website/footer/icon_sh.png')" />
                            </div>
                            <div class="ex-link" id="footer-icon-tt">
                                <img class="icon" :src="$cdnUrl('website/footer/icon_tt.png')" />
                            </div>
                        </div>
                    </div>
                    <img class='icon-img' :src="$cdnUrl('website/footer/icon_gzh.png')"/>
                    <img class='icon-img' :src="$cdnUrl('website/footer/icon_yyx.png')"/>
                </div>
            </div>
            <div class="copyright">
                <a href='https://beian.miit.gov.cn' target="blank"><span class="text">2016-2026 杭州太仆汽车科技有限公司 版权所有 浙ICP备2025168600号</span></a>
                
            </div>
        </el-footer>

        <!-- 侧边悬浮标签 -->
        <div id="overflow-tag">
            <div class="each-tag service-tag">
                <div class="right-box">
                    <img :src=" 'sideBtn/wx_logo.png' | imgsrc" alt="">
                    <p class='name'>立即咨询</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content kf">
                    <img :src="'sideBtn/kfwx_qrcode.png' | imgsrc" alt="">
                    <p class='tip'>添加客服微信</p>
                </div>
            </div>
        
            <div class="each-tag phone-tag">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/phone_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/phone_red.png' | imgsrc" alt="">
                    <p class='name'>联系我们</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content phone">
                    <p class='bold'>拨打客服热线了解更多信息</p>
                    <p class='tip'><span>服务热线：</span>400-666-1098</p>
                    <p class='tip'><span>服务时间：</span>7*24小时</p>
                </div>
            </div>
            <div class="each-tag follow-tag">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/guanzhu_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/guanzhu_red.png' | imgsrc" alt="">
                    <p class='name'>关注我们</p>
                    <p class="line"></p>
                </div>
                <div class="hover-content follow">
                    <div class="each-qrcode fl">
                        <img :src="'sideBtn/gzh_qrcode.png' | imgsrc" alt="">
                        <p class='tip'>关注微信公众号</p>
                        <p class='tip'>获取最新行业资讯</p>
                    </div>
                    <div class="each-qrcode fr">
                        <img :src="'sideBtn/dy_qrcode.jpg' | imgsrc" alt="">
                        <p class='tip'>关注抖音</p>
                        <p class='tip'>获取最新行业资讯</p>
                    </div>
                </div>
            </div>
            <div class="each-tag bdkf-tag" @mouseenter="openJoin">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/zixun_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/zixun_red.png' | imgsrc" alt="">
                    <p class='name'>在线留言</p>
                    <p class="line"></p>
                </div>
                <!-- <div class="hover-content bdkf">
                    <div class='white'>
                        <p class='tip'>在线客服为您一对一进行解答</p>
                        <p class='tip btn' @click='handleOpenBdkf'>点击咨询</p>
                    </div>
                    
                </div> -->
            </div>
            <div class="each-tag back-to-top"  @click="scrollToTop">
                <div class="right-box">
                    <img class="gray" :src=" 'sideBtn/top_gray.png' | imgsrc" alt="">
                    <img class="red" :src=" 'sideBtn/top_red.png' | imgsrc" alt="">
                </div>
            </div>
        </div>
        <div v-if="!isJoinClose" class="join-form-float">
                <div class="title-box">
                    <div class="text">
                        请您留言
                    </div>
                    <div class="icon" @click="closeJoin">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
                <div class="form-box">
                    <div class="info">
                        感谢您的关注，留下您的信息我们会尽快跟您联系，并给您发送我们的合作模式手册!
                    </div>
                    <el-form :model="joinData">
                        <el-form-item>
                            <el-input placeholder="请输入姓名" v-model="joinData.name" clearable><i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input placeholder="请输入手机号码" v-model="joinData.telephone" clearable><i slot="prefix" class="el-input__icon el-icon-phone"></i></el-input>
                        </el-form-item>
                        <el-form-item class="province-input">
                            <el-cascader
                                placeholder="请选择城市"
                                clearable
                                v-model="region"
                                :options="provinceOptions"
                                :props="{ label: 'label', value: 'label' }"
                                @change="handleChange"
                            >
                            </el-cascader>
                            <i class="el-cascader-icon el-input__icon el-icon-location"></i>
                        </el-form-item>
                       <div :class="joinSending ? 'btn disable': 'btn'" @click="createJoinInfo">提交</div>
                    </el-form>
                </div>
        </div>
	</el-container>

    <!-- 手机端 -->
	<el-container v-else class="container-m">
		<el-row  class="header-box"  type="flex" justify="space-between">
            <div class="icon-box" @click="showMenu = true">
                <img :src="$cdnUrl('ios/1562054615458_menu.png')" alt="" class="icon">
            </div>
            <div class="current-nav">{{pageName}}</div>
            <!-- <img src="'nav/m_nav_logo.png' | imgsrc" alt="" class="logo"> -->
            <div class="icon-box">
                <!-- <router-link v-if="!userId" tag="div" to="/login" class="no-login">登录</router-link> -->
                <!-- <router-link v-if="!sessionStorage.getItem('userId')" tag="div" to="/login" class="no-login">登录</router-link> -->
                <!-- <el-dropdown v-else trigger="click">
                    <span class="el-dropdown-link"><img class="user-icon" :src="'nav/icon_nav_ personal.png' | imgsrc" /></span>
                    <el-dropdown-menu slot="dropdown" class="mobile-userinfo-menu">
                        <el-dropdown-item divided @click.native="">
                            
                            <router-link tag="p" to="/userInfo">个人资料</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item divided @click.native="clickLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>

            <!-- 导航栏 -->
            <div v-show="showMenu"  class="side-menu-box" @click.stop="showMenu = false">
                <div class="side-menu">
                    <router-link tag="div" to="/" class="top-logo flex">
                        <img :src="$cdnUrl('ios/menu_logo%402x.png')" alt="">
                    </router-link>
                    <el-menu 
                        :default-active="$route.path" 
                        text-color="#888888"
                        class="el-menu-vertical-demo" 
                        unique-opened 
                        router>
                        <template v-for="(item,index) in $router.options.routes">
                            <el-menu-item :index="item.path" v-if="item.name">{{item.name}}</el-menu-item>
                        </template>
                    </el-menu>
                </div>
            </div>

		</el-row>

        <transition  name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

        <el-footer class="footer" style="height: auto;">
            <div class="tpLogo">
                <img :src="$cdnUrl('ios/nav_logo_footer.png')" alt="一台洗车机多少钱">
            </div>
            <div class="link">
                <router-link to="/">产品介绍</router-link>
                <div class="line"></div>
                <router-link to="/operMarket">运营支持</router-link>
                <div class="line"></div>
                <router-link to="/afterSale">售后支持</router-link>
                <div class="line"></div>
                <router-link to="/about">走进太仆</router-link>
                <div class="line"></div>
                <router-link to="/taipuFuture">太仆未来</router-link>
                <div class="line"></div>
                <router-link to="/cityPartners">城市合伙人</router-link>
            </div>
            <div class="qrcode">
                <img :src="$cdnUrl('ios/yyzc_img_ptzc_qr@2x.png')" alt="自动洗车">
                <img :src="$cdnUrl('ios/yyzc_img_llzh_qr@2x.png')" alt="自动洗车">
                <div class="phone">
                    <p class="desc">全国统一招商热线：</p>
                    <p class="text">400-666-1098</p>
                </div>
            </div>
            <div class="address">
                公司地址：浙江省杭州市余杭区五常街道165号靖源国际4幢8楼
            </div>
            <div class="email">
                电子邮箱：tpqc@taipuauto.cn
            </div>
            <div class="copyright">
                <p>2016-2026 杭州太仆汽车科技有限公司 版权所有 浙ICP备2025168600号</p>
            </div>
        </el-footer>
	</el-container>

</template>

<script>
    import GLOBAL from '@/assets/js/global.js'
    import { logout, submitJoin } from '@/api/api.js'
    import { EventBus } from '@/common/js/event-bus.js'
    import { second_level_geo } from "@/common/js/geo";
	export default {
		data() {
            console.log('second_level_geo: ', second_level_geo)
			return {
                userId: '',  //用户信息，登陆后
                showMenu: false,  //手机是否隐藏菜单
                pageName: '太仆科技',
                eventBus: EventBus,
                joinData: {
                    name: '',
                    telephone: '',
                    suitableSite: 1,
                    prov: null,
                    city: null,
                    intentDesc: ''
                },
                provinceOptions: second_level_geo.geocode,
                region: [],
                isJoinClose: false,
                joinSending: false
			}
        },
       
		methods: {
			
			//退出登录
			clickLogout: function () {
                var that = this;
                logout({}).then(res => {
                    if (res.code == '200') {
                        sessionStorage.clear();
                        that.userId = sessionStorage.getItem('userId') || '';
                        if (that.$route.path == '/userInfo') {
                            that.$router.push({ path: '/login' })
                        }
                    }
                })
			},

            handleChange(value) {
                console.log(value);
                if (Array.isArray(value) && value.length == 2) {
                    this.joinData.prov = value[0]
                    this.joinData.city = value[1]
                }
            },

            closeJoin() {
                this.isJoinClose = true
            },

            openJoin() {
                this.isJoinClose = false
            },

            scrollToTop: function () {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            handleOpenBdkf: function() {
                document.querySelector('#nb_icon_wrap').click()
            },

            toRobot: function(path) {
                EventBus.changeModelIndex(0)
                this.$router.push({ path })
            },

            showThisRobot: function(index, path) {
                console.log('showThisRobot: ', this.$router,this.$route,  this.$route.path == '/robot/c')
                let seriesKey = this.$route.path.split('/').splice(-1)[0]
                if ((['b', 'g', 'w1']).indexOf(seriesKey) != -1) {
                   EventBus.changeCurrentSeriesViewType(2)
                } else if ('w2' == seriesKey) {
                    EventBus.changeCurrentSeriesViewType(3)
                } else if ((['c', 'd']).indexOf(seriesKey) != -1) {
                    EventBus.changeCurrentSeriesViewType(1)
                }
                if (this.$route.path == path) {
                    EventBus.changeModelIndex(index)
                } else {
                    this.$router.push({ path: `${path}?index=${index}` })
                }

                
            },

            navActiveClass: function(nav) {
                // console.log('navActiveClas:', nav, this.$router.currentRoute.matched[0].path, this.$router.currentRoute.matched)
                // 顶部导航目前只有两层，下面按两层写死
                let currentPath = this.$router.currentRoute.matched[0].path || this.$router.currentRoute.matched[1].path
                let selfActive = false
                let childrenActive = false
                if(currentPath == nav.path){
                    selfActive = true
                } else {
                    for (let item of nav.children) {
                        if(currentPath == item.path){
                            childrenActive = true
                            break
                        }
                    }
                }
                return `${selfActive ? 'self-active':''} ${childrenActive ? 'child-active':''}`
            },

            setPageName: function() {
                console.log('setPageName: ', this.$router.currentRoute.matched, this.$router)
                this.pageName = this.$router.currentRoute.matched[0].name
            },

            // 创建加盟信息
            createJoinInfo: function() {
                console.log('this.joinData', this.joinData)
                let that = this
                if(this.joinSending) { 
                    // this.$message.error('请勿重复点击');
                    return
                }
                if (!this.joinData.name) {
                    this.$message.error('请输入姓名');
                    return
                }
                if (!this.joinData.telephone) {
                    this.$message.error('请输入手机号码');
                    return
                }
                if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.joinData.telephone))){ 
                    this.$message.error('请输入正确的手机号码');
                    return
                }
                that.joinSending = true
                let p = {
                    phoneNumber: this.joinData.telephone,
                    province: this.joinData.prov,
                    city: this.joinData.city,
                    siteStatus: this.joinData.suitableSite,
                    requirements: this.joinData.intentDesc,
                    userName: this.joinData.name
                }
                submitJoin(p).then(
                    function(res) {
                        if (res.code == 200) {
                            that.$message.success('感谢您的关注，留下您的信息，我们会尽快跟您联系，并给您发送我们的合作模式手册！');
                            that.joinData = {
                                name: '',
                                telephone: '',
                                suitableSite: null,
                                prov: null,
                                city: null,
                                intentDesc: ''
                            }
                            that.region = []
                            return
                        }
                        that.$message.error('提交失败, 请重试')
                    },
                    function() {
                        that.$message.error('提交失败, 请重试')
                        
                    }
                ).finally(() => {
                    setTimeout(() => {
                        that.joinSending = false
                    }, 1000)
                })
            },  

            // 监听省选择
            provinceChange: function(value) {
                console.log('provinceChange: ', value)
                for (let item of this.provinceOptions) {
                    if (item.label == value) {
                        this.cityOptions = item.children
                    }
                }
            },
		},
		mounted() {
            this.userId = sessionStorage.getItem('userId') || '';
            // console.log('{{$this.$router.currentRoute}}', this.$router.currentRoute)
		},

        computed: {
            // navActiveClass: function (item) {
            //     // let routes = this.$router.options.routes
            //     // for 
            //     // return {
                    
            //     // }
            //     console.log('navActiveClas:', arguments)
            // }
        },
        
        watch: {
            '$route': 'setPageName'
        }
	}
</script>

<style lang="scss" src="../styles/components/Layout.global.1.scss"></style>

<style src="../styles/components/Layout.global.2.css"></style>
